'use client';

import React from 'react';
import { motion } from 'framer-motion';
import { Package } from 'lucide-react';
import styles from './DashboardDemo.module.css';

export const DashboardDemo = () => {
    return (
        <motion.div
            className={styles.container}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <div className={styles.header}>
                <div className={styles.iconWrapper}>
                    <Package className={styles.icon} />
                </div>
                <h3 className={styles.title}>Личный кабинет</h3>
            </div>

            <div className={styles.statsGrid}>
                <motion.div
                    className={styles.statCard}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                >
                    <div className={styles.statValue}>142</div>
                    <div className={styles.statLabel}>Доставки</div>
                </motion.div>

                <motion.div
                    className={styles.statCard}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                >
                    <div className={styles.statValue}>24</div>
                    <div className={styles.statLabel}>Активные</div>
                </motion.div>

                <motion.div
                    className={styles.statCard}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                >
                    <div className={styles.statValue}>98.7%</div>
                    <div className={styles.statLabel}>Вручено</div>
                </motion.div>
            </div>

            <div className={styles.tabs}>
                <button className={`${styles.tabButton} ${styles.activeTab}`}>Доставки</button>
                <button className={styles.tabButton}>Аналитика</button>
                <button className={styles.tabButton}>Финансы</button>
            </div>

            <div className={styles.deliveriesList}>
                <motion.div
                    className={styles.deliveryItem}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.4 }}
                >
                    <div className={styles.deliveryId}>#900123456789</div>
                    <div className={styles.deliveryStatus}>В пути в Москву</div>
                </motion.div>

                <motion.div
                    className={styles.deliveryItem}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.5 }}
                >
                    <div className={styles.deliveryId}>#900123456790</div>
                    <div className={styles.deliveryStatus}>Прибыл в пункт выдачи</div>
                </motion.div>
            </div>

            <motion.button
                className={styles.actionButton}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
            >
                Войти в кабинет
            </motion.button>
        </motion.div>
    );
};
